module.exports = __webpack_public_path__ + "static/media/photo54.877ba497.jpg";